import { connect } from 'react-redux';

import ProbingOptionsPane from '../components/ProbingOptionsPane';

export default connect(
  (state, ownProps) => {
    return {
    };
  },
  (dispatch, ownProps) => ({
  })
)(ProbingOptionsPane);
